import {
  DeleteWithConfirmButton,
  ListButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";
import { DateFieldWithStandardFormat } from "@/fields/DateFieldWithStandardFormat";
import { ReferenceField } from "@/fields/ReferenceField";

import { LandingDomainDeleteAfterButton } from "./LandingDomainDeleteAfterButton";

const ShowActions = () => {
  return (
    <TopToolbar sx={{ justifyContent: "space-between" }}>
      <ListButton />
      <DeleteWithConfirmButton label="Delete Now" />
      <LandingDomainDeleteAfterButton />
    </TopToolbar>
  );
};

export const LandingDomainsShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="url" emptyText="-" />
      <ReferenceField
        source="region.id"
        module={MODULE_NAMES.LANDING_REGIONS}
        label="Region"
        emptyText="-"
      />
      <DateFieldWithStandardFormat source="expiresAt" sortable={false} />
    </SimpleShowLayout>
  </Show>
);
